export default __webpack_public_path__ + "static/media/thankyou.3a604b22.svg";